import React from 'react'

export function LoadingButton() {
    return (
        <button class="btn btn-info" disabled>
            <i class="ace-icon fa fa-check bigger-110"></i> Please Wait...
        </button>
    )
}
